function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { FloatingFocusManager, useMergeRefs } from '@floating-ui/react';
import { forwardRef, useCallback } from 'react';
import { Blanket } from '../../../components/feedback';
import { Box, Portal } from '../../../components/internal';
import { Slide } from '../../../foundations';
import { useBreakpointValue } from '../../../theme';
import { zIndices } from '../../../theme/foundations';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { useDrawerContext } from '../DrawerContext';
/**
 * @private For internal use only. Should be consumed only by `Drawer`.
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DrawerContent = /*#__PURE__*/forwardRef((props, propRef) => {
  var styles = useMultiStyleConfig('Drawer', {});
  var {
    context,
    isOpen,
    onCloseComplete,
    getFloatingProps,
    refs,
    labelId,
    descriptionId,
    getTestId
  } = useDrawerContext();
  var ref = useMergeRefs([refs.setFloating, propRef]);
  var width = useBreakpointValue({
    xs: '100vw',
    s: '708px'
  });
  var onAnimationComplete = useCallback(definition => {
    if (definition === 'enter') return;
    onCloseComplete === null || onCloseComplete === void 0 ? void 0 : onCloseComplete();
  }, [onCloseComplete]);
  return /*#__PURE__*/_jsxs(Portal, {
    children: [/*#__PURE__*/_jsx(Blanket, _objectSpread({
      isOpen: isOpen,
      isFullScreen: true
    }, getTestId('overlay'))), /*#__PURE__*/_jsx(Slide, {
      direction: "right",
      in: isOpen,
      unmountOnExit: true,
      style: {
        zIndex: zIndices.modal,
        width,
        maxWidth: width
      },
      onAnimationComplete: onAnimationComplete,
      transition: {
        enter: {
          duration: 0.3
        },
        exit: {
          duration: 0.3
        }
      },
      children: /*#__PURE__*/_jsx(FloatingFocusManager, {
        context: context,
        children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
          as: "section",
          __css: styles['content'],
          ref: ref,
          "aria-labelledby": labelId,
          "aria-describedby": descriptionId
        }, getTestId()), getFloatingProps(props)))
      })
    })]
  });
});
DrawerContent.displayName = 'DrawerContent';
//# sourceMappingURL=DrawerContent.js.map